const env = { API_URL: 'https://dev.api.cohortai.com/crud' } ;
export default env
